import React from "react";

export default function AprilFoolDay2({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-apr21{fill:#fcd26b}.cls-apr22{fill:#b5fc2b}.cls-apr23{fill:#cf13ea}.cls-apr24{fill:#a6e019}.cls-apr25{fill:#efac07}.cls-apr26{fill:#fec629}.cls-apr27{fill:#d2ff64}.cls-apr28{fill:#ed71ff}.cls-apr29{fill:#e72bfc}"
            }
          </style>
        </defs>
        <path
          d="M1467.99 1706.45c-.99 0-1.98-.42-2.67-1.24a3.491 3.491 0 0 1 .41-4.93c73.91-62.59 125.54-120.9 153.45-173.3 21.53-40.43 29.33-78.24 23.16-112.4-1.72-9.55-4.78-20.22-8.01-31.52-9.96-34.84-22.36-78.2-10.38-132.68 6.71-30.52 20.08-59.78 39.73-87a3.503 3.503 0 0 1 5.68 4.1c-19.09 26.43-32.07 54.83-38.57 84.4-11.59 52.75.53 95.17 10.28 129.26 3.28 11.48 6.38 22.31 8.17 32.21 6.45 35.74-1.58 75.09-23.87 116.94-28.33 53.19-80.52 112.19-155.11 175.35-.66.56-1.46.83-2.26.83Z"
          className="cls-apr25"
        />
        <path
          d="M1948.73 764.04c-13.12-68.06-65.75-167.35-160.71-189.25-92.85-21.42-182.06 41.33-223.66 95.03-87.12 112.46-63.69 312.03 68.42 494.08-2.17 7.34-7.7 22.32-21.67 35.59-10 9.5-20.37 14.37-26.99 16.86 8.46 7.29 28.65 22.58 58.42 26.4 16.62 2.13 30.59-.03 39.93-2.32a176.4 176.4 0 0 0-2.72-26.44 175.873 175.873 0 0 0-12.44-40.39c198.47-101.72 308.44-269.3 281.41-409.55Z"
          className="cls-apr26"
        />
        <path
          d="M1667.32 1173.59c4.67 10.51 9.5 24.11 12.43 40.39 1.75 9.69 2.51 18.59 2.73 26.43-9.34 2.29-23.31 4.46-39.93 2.33a107.556 107.556 0 0 1-27.86-7.49c-14.71-6.14-25.09-14.2-30.56-18.92 6.62-2.49 16.99-7.36 26.99-16.85 12.73-12.1 18.45-25.62 21.01-33.47.1-.32.2-.62.29-.91 198.11-101.75 307.85-269.14 280.85-409.26-12.28-63.74-59.24-154.88-143.16-184.17 5.95.7 11.92 1.73 17.91 3.11 94.96 21.9 147.59 121.2 160.7 189.25 27.03 140.25-82.94 307.82-281.41 409.56Z"
          className="cls-apr25"
        />
        <path
          d="M1647.02 1232.22c-7.88 1.93-19.05 3.78-32.33 3.03-14.71-6.14-25.09-14.2-30.56-18.92 6.62-2.49 16.99-7.36 26.99-16.85 12.73-12.1 18.45-25.62 21.01-33.47a176.175 176.175 0 0 1 14.89 66.21Z"
          className="cls-apr26"
        />
        <path
          d="M1562.25 784.78c-10.95 52.33-2.19 84.32-7.55 85.2-6.95 1.14-33.53-50.54-19.5-101.14 11.8-42.57 48.67-71.22 54.45-67.37 5.09 3.4-16.34 30.48-27.4 83.32Z"
          className="cls-apr21"
        />
        <circle cx={1621.4} cy={672.8} r={13.9} className="cls-apr21" />
        <circle cx={1566.59} cy={910.07} r={13.9} className="cls-apr21" />
        <path
          d="M985.3 861.71c-1.18 0-2.34-.6-3-1.69-17.45-28.85-23.67-55.09-18.51-78.01 1.46-6.47 3.26-10.79 6.25-17.94 3.04-7.28 7.64-18.27 14.67-38.43 3.67-10.49 6.96-21.18 10.08-32.68 3.86-14.25 7.18-28.78 9.85-43.19.35-1.9 2.18-3.16 4.08-2.8 1.9.35 3.16 2.18 2.8 4.08a552.306 552.306 0 0 1-9.98 43.74c-3.16 11.66-6.51 22.51-10.23 33.16-7.11 20.35-11.75 31.47-14.82 38.82-2.94 7.03-4.56 10.91-5.88 16.78-4.76 21.09 1.19 45.59 17.67 72.84a3.508 3.508 0 0 1-2.99 5.32Z"
          className="cls-apr25"
        />
        <path
          d="M1103.4 436.69c-14-29.98-50.99-70.28-100.38-70.61-48.29-.33-85.5 37.71-100.15 66.7-30.69 60.71 2.92 150.16 88.36 220.39-.26 3.6-1.35 11.06-6.79 18.61-3.9 5.4-8.49 8.71-11.49 10.53 4.99 2.48 16.66 7.45 31.81 6.15 8.46-.72 15.13-3.15 19.49-5.17-.97-3.59-2.33-7.61-4.26-11.89a81.914 81.914 0 0 0-10.61-17.31c86.95-67.2 122.86-155.62 94.02-217.4Z"
          className="cls-apr26"
        />
        <path
          d="M1009.39 654.09c3.47 4.36 7.36 10.12 10.61 17.31 1.93 4.28 3.29 8.3 4.26 11.89a58.725 58.725 0 0 1-19.5 5.17c-5.35.46-10.27.14-14.61-.59a61.317 61.317 0 0 1-17.21-5.57c3-1.82 7.59-5.13 11.49-10.53 4.96-6.88 6.3-13.69 6.7-17.56.01-.16.03-.31.04-.45 86.77-67.17 122.59-155.48 93.77-217.21-13.11-28.08-46.39-65.21-91.14-70.07 3.02-.29 6.09-.43 9.21-.41 49.39.33 86.38 40.63 100.38 70.61 28.85 61.78-7.07 150.2-94.01 217.4Z"
          className="cls-apr25"
        />
        <path
          d="M1005.81 683.16c-3.69 1.7-9.01 3.7-15.66 4.71a61.317 61.317 0 0 1-17.21-5.57c3-1.82 7.59-5.13 11.49-10.53 4.96-6.88 6.3-13.69 6.7-17.56 3.42 4.33 7.22 10 10.41 17.06 1.93 4.28 3.29 8.3 4.26 11.89Z"
          className="cls-apr26"
        />
        <path
          d="M914.52 485.92c.36 25.21 8.22 39.03 5.66 39.99-3.31 1.24-22.16-19.82-20.81-44.55 1.14-20.81 16.22-37.78 19.5-36.6 2.89 1.04-4.72 15.71-4.36 41.16Z"
          className="cls-apr21"
        />
        <ellipse
          cx={931.42}
          cy={428.3}
          className="cls-apr21"
          rx={7.04}
          ry={6.55}
        />
        <ellipse
          cx={930.48}
          cy={543.14}
          className="cls-apr21"
          rx={7.04}
          ry={6.55}
        />
        <path
          d="M1379.29 872.06c-1.58 0-3.01-1.07-3.4-2.67-4.25-17.38-3.2-31.72 3.12-42.62 1.8-3.09 3.39-4.99 6.03-8.13 2.61-3.11 6.57-7.8 13.13-16.62 3.41-4.58 6.67-9.31 9.97-14.47 4.09-6.4 7.95-13.02 11.48-19.67a3.492 3.492 0 0 1 4.73-1.45c1.71.91 2.36 3.02 1.45 4.73-3.62 6.82-7.57 13.61-11.77 20.16-3.39 5.3-6.74 10.17-10.25 14.88-6.69 8.99-10.72 13.78-13.39 16.95-2.48 2.94-3.84 4.57-5.33 7.13-5.39 9.28-6.19 21.88-2.38 37.44a3.497 3.497 0 0 1-3.4 4.33Z"
          className="cls-apr25"
        />
        <path
          d="M1502.86 678.79c-2.27-16.96-14.29-42.58-38.61-50.4-23.79-7.64-48.04 5.38-59.76 17.41-24.55 25.21-21.81 74.57 9.49 122.47-.69 1.74-2.38 5.25-6.23 8.13-2.76 2.06-5.54 2.98-7.3 3.42 2.08 2 7.07 6.26 14.75 7.96 4.29.95 7.96.79 10.42.47.08-1.92.03-4.12-.26-6.53a42.41 42.41 0 0 0-2.56-10.19c53.32-19.7 84.74-57.79 80.07-92.75Z"
          className="cls-apr26"
        />
        <path
          d="M1422.79 771.54c1.04 2.69 2.07 6.13 2.55 10.19.29 2.41.34 4.61.26 6.53a30.23 30.23 0 0 1-17.54-3.02 31.66 31.66 0 0 1-7.63-5.41c1.76-.44 4.54-1.36 7.3-3.42 3.51-2.63 5.23-5.78 6.03-7.63.03-.07.06-.15.09-.21 53.23-19.72 84.59-57.76 79.92-92.69-2.12-15.89-12.8-39.37-34.13-48.7 1.54.33 3.07.73 4.61 1.23 24.33 7.81 36.35 33.43 38.61 50.4 4.67 34.96-26.75 73.04-80.07 92.75Z"
          className="cls-apr25"
        />
        <path
          d="M1416.52 785.33c-2.08.27-5.02.43-8.46-.1a31.66 31.66 0 0 1-7.63-5.41c1.76-.44 4.54-1.36 7.3-3.42 3.51-2.63 5.23-5.78 6.03-7.63a42.39 42.39 0 0 1 2.49 10.03c.29 2.41.34 4.61.26 6.53Z"
          className="cls-apr26"
        />
        <path
          d="M1402 673.83c-3.73 12.5-1.99 20.54-3.4 20.62-1.83.1-7.87-13.21-3.37-25.21 3.78-10.09 13.86-16.14 15.29-15.05 1.27.96-4.76 7.02-8.53 19.64Z"
          className="cls-apr21"
        />
        <ellipse
          cx={1419.27}
          cy={648.01}
          className="cls-apr21"
          rx={3.39}
          ry={3.64}
          transform="rotate(-72.58 1419.307 648.004)"
        />
        <ellipse
          cx={1401.02}
          cy={704.55}
          className="cls-apr21"
          rx={3.39}
          ry={3.64}
          transform="rotate(-72.58 1401.065 704.546)"
        />
        <path
          d="M725.93 866.15c-1.55 0-2.96-1.03-3.38-2.6-4.94-18.5-11.44-36.8-19.32-54.38-7.87-17.57-14.63-28.82-20.06-37.86-7.54-12.56-13-21.64-16.06-38.16-3.82-20.59-.79-37.6 5.26-71.49a428.78 428.78 0 0 1 15.1-59.52 3.493 3.493 0 0 1 4.42-2.22 3.5 3.5 0 0 1 2.22 4.42c-6.32 19.01-11.31 38.71-14.85 58.54-5.9 33.05-8.86 49.65-5.27 68.98 2.84 15.27 7.75 23.45 15.18 35.83 5.52 9.2 12.4 20.65 20.44 38.6a367.842 367.842 0 0 1 19.69 55.44c.5 1.87-.61 3.79-2.48 4.28-.3.08-.61.12-.9.12Z"
          className="cls-apr24"
        />
        <path
          d="M772.06 305.14c-24.04-36.64-79.8-82.47-143.55-73.6-62.34 8.67-102.7 65.52-115.8 106.25-27.43 85.31 33.8 196.18 158.01 272.1.38 4.77.48 14.75-5.04 25.66-3.95 7.81-9.2 13-12.71 15.96 6.93 2.31 22.98 6.62 42.25 2.07a74.701 74.701 0 0 0 24.1-10.44c-1.97-4.52-4.53-9.53-7.87-14.77-5.63-8.81-11.79-15.63-17.14-20.69 98.68-104.42 127.31-227.03 77.76-302.54Z"
          className="cls-apr22"
        />
        <path
          d="M694.31 607.68c5.35 5.06 11.51 11.87 17.14 20.69 3.35 5.24 5.9 10.25 7.88 14.77a75.076 75.076 0 0 1-24.11 10.45 74.85 74.85 0 0 1-18.95 1.98 79.26 79.26 0 0 1-23.3-4.06c3.5-2.96 8.76-8.15 12.71-15.96 5.02-9.94 5.39-19.12 5.13-24.27l-.03-.6c98.45-104.35 126.98-226.8 77.48-302.24-22.52-34.32-72.86-76.7-131.53-74.64 3.84-.95 7.77-1.71 11.79-2.27 63.75-8.87 119.51 36.96 143.55 73.6 49.55 75.51 20.92 198.12-77.75 302.54Z"
          className="cls-apr24"
        />
        <path
          d="M695.51 646.44a75.113 75.113 0 0 1-19.25 9.13 79.26 79.26 0 0 1-23.3-4.06c3.5-2.96 8.76-8.15 12.71-15.96 5.02-9.94 5.39-19.12 5.13-24.27 5.27 5.02 11.31 11.75 16.83 20.39 3.35 5.24 5.9 10.25 7.88 14.77Z"
          className="cls-apr22"
        />
        <path
          d="M538.34 405.21c5.5 32.96 18.41 49.59 15.3 51.33-4.02 2.25-32.54-21.79-35.74-54.45-2.69-27.47 13.36-52.55 17.83-51.63 3.94.82-2.94 21.47 2.61 54.75Z"
          className="cls-apr27"
        />
        <ellipse
          cx={548.62}
          cy={326.54}
          className="cls-apr27"
          rx={9.18}
          ry={8.68}
          transform="rotate(-5.17 548.89 326.63)"
        />
        <ellipse
          cx={570.38}
          cy={477.17}
          className="cls-apr27"
          rx={9.18}
          ry={8.68}
          transform="rotate(-5.17 570.603 477.426)"
        />
        <path
          d="M1133.91 855.35h-.15a3.507 3.507 0 0 1-3.35-3.65c.31-7.07.04-14.24-.79-21.32-.83-7.05-1.97-11.78-2.89-15.57-1.29-5.37-2.32-9.6-1.51-16.26.99-8.21 4.06-14.08 10.16-25.78 3.61-6.92 7.74-13.61 12.27-19.9a3.503 3.503 0 0 1 5.68 4.1c-4.34 6.02-8.29 12.42-11.74 19.04-5.71 10.95-8.58 16.44-9.42 23.38-.65 5.4.11 8.55 1.37 13.78.96 3.98 2.15 8.92 3.03 16.39.88 7.44 1.16 14.99.84 22.44a3.499 3.499 0 0 1-3.49 3.35Z"
          className="cls-apr24"
        />
        <path
          d="M1213.14 657.19c-4.5-15.84-19.33-38.54-43.18-42.53-23.32-3.9-44.18 11.93-53.46 25.06-19.43 27.5-9.95 74.12 26.04 115.3-.4 1.75-1.49 5.34-4.69 8.63a19.175 19.175 0 0 1-6.35 4.29c2.22 1.61 7.49 4.96 14.91 5.49 4.14.3 7.55-.38 9.81-1.03-.2-1.84-.55-3.93-1.16-6.18a41.314 41.314 0 0 0-3.82-9.34c47.11-26.33 71.16-67.06 61.89-99.7Z"
          className="cls-apr22"
        />
        <path
          d="M1151.24 756.89c1.35 2.41 2.79 5.55 3.82 9.34.61 2.26.96 4.34 1.16 6.18-2.26.65-5.67 1.33-9.82 1.03a28.4 28.4 0 0 1-7.02-1.42 29.855 29.855 0 0 1-7.9-4.07c1.59-.67 4.06-1.94 6.35-4.29 2.92-3 4.08-6.25 4.57-8.12.02-.08.04-.15.05-.22 47.03-26.33 71.02-67.02 61.76-99.62-4.21-14.83-17.49-35.68-38.75-41.55 1.48.09 2.98.26 4.48.51 23.85 3.99 38.68 26.69 43.18 42.53 9.27 32.64-14.78 73.37-61.89 99.7Z"
          className="cls-apr24"
        />
        <path
          d="M1147.32 770.92c-1.91.55-4.63 1.12-7.93 1.11a29.855 29.855 0 0 1-7.9-4.07c1.59-.67 4.06-1.94 6.35-4.29 2.92-3 4.08-6.25 4.57-8.12 1.33 2.39 2.73 5.48 3.74 9.2.61 2.26.96 4.34 1.16 6.18Z"
          className="cls-apr22"
        />
        <path
          d="M1118.11 666.78c-1.74 12.43 1.02 19.85-.29 20.12-1.69.35-9.21-11.47-6.69-23.54 2.12-10.15 10.7-17.34 12.2-16.5 1.32.74-3.47 7.36-5.22 19.92Z"
          className="cls-apr27"
        />
        <ellipse
          cx={1130.64}
          cy={639.74}
          className="cls-apr27"
          rx={3.26}
          ry={3.45}
          transform="rotate(-77.75 1130.707 639.722)"
        />
        <ellipse
          cx={1121.5}
          cy={696.18}
          className="cls-apr27"
          rx={3.26}
          ry={3.45}
          transform="rotate(-77.75 1121.57 696.169)"
        />
        <path
          d="M494.04 1295.96c-.76 0-1.52-.24-2.16-.75-68.79-54.06-116.92-104.57-143.07-150.13-20.63-35.94-28.05-69.75-22.08-100.5 1.65-8.5 4.51-17.79 7.54-27.62 8.96-29.07 20.1-65.26 9.46-110.2-5.97-25.21-17.89-49.42-35.44-71.96a3.5 3.5 0 0 1 5.52-4.3c18.17 23.34 30.53 48.46 36.73 74.65 11.08 46.79-.38 83.99-9.58 113.87-2.97 9.65-5.78 18.76-7.36 26.9-5.65 29.05 1.51 61.24 21.28 95.68 25.7 44.77 73.24 94.6 141.32 148.11a3.498 3.498 0 0 1-2.16 6.25Z"
          className="cls-apr23"
        />
        <path
          d="M50.96 489.3c12.09-58.22 60.6-143.15 148.12-161.89 85.58-18.32 167.8 35.35 206.14 81.29 80.29 96.2 58.7 266.91-63.06 422.64 2 6.28 7.1 19.09 19.97 30.44 9.21 8.12 18.77 12.29 24.87 14.42-7.8 6.23-26.41 19.31-53.84 22.58-15.32 1.82-28.19-.03-36.8-1.99.2-6.71.9-14.33 2.51-22.61 2.7-13.93 7.16-25.56 11.46-34.55C127.4 752.62 26.04 609.28 50.96 489.3Z"
          className="cls-apr29"
        />
        <path
          d="M310.32 839.64c-4.31 8.99-8.76 20.62-11.46 34.55a140.36 140.36 0 0 0-2.51 22.61c8.61 1.96 21.49 3.81 36.8 1.99 9.69-1.16 18.28-3.53 25.67-6.4 13.55-5.26 23.12-12.15 28.17-16.18-6.1-2.13-15.66-6.3-24.87-14.42-11.73-10.35-17.01-21.92-19.37-28.63-.09-.27-.18-.53-.27-.78C159.89 745.34 58.75 602.15 83.63 482.29c11.32-54.52 54.6-132.49 131.94-157.54-5.48.6-10.99 1.48-16.51 2.66C111.54 346.15 63.03 431.08 50.94 489.3 26.03 609.28 127.39 752.61 310.3 839.64Z"
          className="cls-apr23"
        />
        <path
          d="M329.03 889.8c7.26 1.65 17.56 3.23 29.8 2.59 13.55-5.26 23.12-12.15 28.17-16.18-6.1-2.13-15.66-6.3-24.87-14.42-11.73-10.35-17.01-21.92-19.37-28.63-4.23 8.92-8.56 20.36-11.21 34.03a140.36 140.36 0 0 0-2.51 22.61Z"
          className="cls-apr29"
        />
        <path
          d="M407.16 507.05c10.09 44.76 2.02 72.13 6.96 72.88 6.4.98 30.9-43.23 17.97-86.52-10.87-36.42-44.86-60.93-50.19-57.63-4.69 2.9 15.06 26.07 25.25 71.27Z"
          className="cls-apr28"
        />
        <ellipse
          cx={352.64}
          cy={411.26}
          className="cls-apr28"
          rx={12.81}
          ry={11.89}
        />
        <ellipse
          cx={403.16}
          cy={614.22}
          className="cls-apr28"
          rx={12.81}
          ry={11.89}
        />
        <path
          d="M1214.21 862.55a3.497 3.497 0 0 1-2.56-5.88c13.84-14.9 25.4-31.12 34.38-48.19 20.92-39.8 23.33-75.15 25.88-112.57 2.34-34.29 4.75-69.75 20.29-113.81a342.543 342.543 0 0 1 26.3-57.18c.97-1.67 3.11-2.25 4.78-1.28 1.67.97 2.25 3.11 1.28 4.78a335.702 335.702 0 0 0-25.76 56.01c-15.22 43.15-17.6 78.13-19.91 111.95-2.6 38.18-5.06 74.25-26.67 115.36-9.26 17.62-21.19 34.34-35.44 49.69-.69.74-1.63 1.12-2.57 1.12Z"
          className="cls-apr23"
        />
        <path
          d="M1509.11 261.61c-8.72-44.94-43.71-110.51-106.83-124.97-61.72-14.15-121.02 27.29-148.68 62.75-57.91 74.26-42.34 206.05 45.49 326.27-1.44 4.85-5.12 14.74-14.41 23.5-6.64 6.27-13.54 9.49-17.94 11.13 5.63 4.81 19.04 14.91 38.84 17.43 11.05 1.41 20.34-.02 26.54-1.53a115.365 115.365 0 0 0-10.08-44.13c131.93-67.18 205.04-177.83 187.07-270.45Z"
          className="cls-apr29"
        />
        <path
          d="M1322.05 532.06c3.11 6.94 6.32 15.92 8.27 26.67 1.16 6.4 1.67 12.27 1.81 17.45-6.21 1.51-15.5 2.94-26.54 1.54a72.157 72.157 0 0 1-18.52-4.94c-9.78-4.06-16.68-9.38-20.32-12.49 4.4-1.64 11.29-4.86 17.94-11.13 8.46-7.99 12.27-16.92 13.97-22.1.07-.21.13-.41.19-.6 131.69-67.19 204.64-177.73 186.69-270.26-8.16-42.09-39.38-102.28-95.16-121.62 3.95.46 7.93 1.14 11.91 2.06 63.12 14.46 98.11 80.03 106.83 124.97 17.97 92.62-55.14 203.27-187.07 270.46Z"
          className="cls-apr23"
        />
        <path
          d="M1308.55 570.78c-5.24 1.27-12.67 2.49-21.49 2-9.78-4.06-16.68-9.38-20.32-12.49 4.4-1.64 11.29-4.86 17.94-11.13 8.46-7.99 12.27-16.92 13.97-22.1a116.13 116.13 0 0 1 8.09 26.27c1.16 6.4 1.67 12.27 1.81 17.45Z"
          className="cls-apr29"
        />
        <path
          d="M1252.2 275.31c-7.28 34.56-1.45 55.68-5.02 56.26-4.62.75-22.29-33.37-12.96-66.79 7.84-28.11 32.36-47.03 36.2-44.49 3.39 2.24-10.86 20.13-18.21 55.02Z"
          className="cls-apr28"
        />
        <ellipse
          cx={1291.52}
          cy={201.36}
          className="cls-apr28"
          rx={9.24}
          ry={9.18}
        />
        <ellipse
          cx={1255.09}
          cy={358.04}
          className="cls-apr28"
          rx={9.24}
          ry={9.18}
        />
        <path
          d="M835.15 867.48c-.51 0-1.02-.11-1.51-.35a3.5 3.5 0 0 1-1.64-4.67c2.82-5.87 4.72-11.88 5.67-17.86 2.2-13.91-1.09-24.24-4.89-36.2-3.32-10.43-7.07-22.25-7.16-37.83-.04-7.01.65-14.05 2.04-20.92a3.5 3.5 0 1 1 6.86 1.4 95.033 95.033 0 0 0-1.9 19.48c.08 14.52 3.52 25.31 6.83 35.75 3.9 12.27 7.59 23.86 5.13 39.41-1.05 6.65-3.16 13.31-6.27 19.8a3.506 3.506 0 0 1-3.16 1.99Z"
          className="cls-apr23"
        />
        <path
          d="M862.9 648.54c-8.53-12.81-28.64-29.06-52.11-26.56-22.96 2.45-38.23 21.65-43.37 35.56-10.75 29.11 10.83 67.78 55.83 94.97.1 1.64.06 5.08-2.06 8.78-1.51 2.65-3.48 4.39-4.79 5.38 2.53.86 8.38 2.48 15.49 1.08 3.97-.78 6.99-2.24 8.93-3.39-.69-1.57-1.59-3.32-2.77-5.15-2-3.08-4.2-5.48-6.13-7.26 37.07-35.07 48.56-77.01 30.97-103.41Z"
          className="cls-apr29"
        />
        <path
          d="M831.93 751.95c1.92 1.79 4.13 4.18 6.13 7.26a34.9 34.9 0 0 1 2.77 5.15c-1.95 1.15-4.96 2.6-8.93 3.39-2.51.49-4.87.61-6.97.52-3.86-.17-6.89-1.04-8.52-1.6 1.31-.99 3.28-2.73 4.79-5.38 1.92-3.38 2.13-6.53 2.08-8.31v-.21c36.98-35.05 48.44-76.93 30.87-103.31-7.99-12-26.13-27.01-47.69-26.81 1.42-.29 2.86-.52 4.35-.68 23.48-2.5 43.58 13.75 52.11 26.56 17.59 26.4 6.09 68.34-30.97 103.41Z"
          className="cls-apr23"
        />
        <path
          d="M832.06 765.3c-1.64.97-4.05 2.16-7.14 2.97-3.86-.17-6.89-1.04-8.52-1.6 1.31-.99 3.28-2.73 4.79-5.38 1.92-3.38 2.13-6.53 2.08-8.31 1.9 1.77 4.06 4.14 6.02 7.16a34.9 34.9 0 0 1 2.77 5.15Z"
          className="cls-apr29"
        />
        <path
          d="M776.3 680.95c1.75 11.39 6.36 17.22 5.21 17.79-1.49.74-11.77-7.78-12.68-19.04-.77-9.48 5.33-17.96 6.96-17.61 1.44.32-1.25 7.36.52 18.86Z"
          className="cls-apr28"
        />
        <ellipse
          cx={780.7}
          cy={653.98}
          className="cls-apr28"
          rx={3.37}
          ry={2.99}
          transform="rotate(-1 783.278 656.03)"
        />
        <ellipse
          cx={787.48}
          cy={705.99}
          className="cls-apr28"
          rx={3.37}
          ry={2.99}
          transform="rotate(-1 790.271 708.233)"
        />
        <path
          d="M1362.27 1866.21H587.54c-69.87 0-126.71-56.84-126.71-126.71V964.77c0-69.87 56.84-126.71 126.71-126.71h774.73c69.87 0 126.71 56.84 126.71 126.71v774.73c0 69.87-56.84 126.71-126.71 126.71ZM587.54 880.05c-46.71 0-84.71 38-84.71 84.71v774.73c0 46.71 38 84.71 84.71 84.71h774.73c46.71 0 84.71-38 84.71-84.71V964.76c0-46.71-38-84.71-84.71-84.71H587.54Z"
          className="cls-apr22"
        />
        {children}
      </g>
    </svg>
  );
}
